const AVATAR_URL_FIELDS = [
  'avatarUrl',
  'avatar',
  'urlAvatar',
  'foto',
  'imagem',
  'urlFoto',
  'photo',
  'picture',
];

export function getUserDisplayName(user) {
  if (!user) {
    return 'Usuário';
  }

  return user.descricao || user.nome || user.usuario || 'Usuário';
}

export function getUserPalavraChave2FA(user) {
  if (!user?.autenticacao2FA?.palavraChave2FA) {
    return '';
  }

  const palavra = user.autenticacao2FA.palavraChave2FA;
  return typeof palavra === 'string' ? palavra.trim() : '';
}

export function getUserAvatarUrl(user) {
  if (!user) {
    return '';
  }

  for (const field of AVATAR_URL_FIELDS) {
    const value = user[field];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return '';
}

export function getUserAvatarSeed(user) {
  if (!user) {
    return '';
  }

  return user.id || user.usuario || getUserDisplayName(user);
}

export function getUserInitials(name) {
  const normalized = (name || '').trim();
  if (!normalized) {
    return '?';
  }

  const parts = normalized.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }

  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
}

export function getUserAvatarColor(seed) {
  const str = seed || 'usuario';
  let hash = 0;

  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = (hash % 360 + 360) % 360;
  return `hsl(${hue}, 65%, 44%)`;
}
